import React from "react";
import { useLang } from "../context/LanguageContext";

const ABOUT_IMG = "https://images.unsplash.com/photo-1761701391167-863560b27f5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxmaWxtJTIwY2FtZXJhJTIwc3R1ZGlvJTIwZGFya3xlbnwwfHx8fDE3NzgyODI1MjZ8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-40 px-6 md:px-12"
    >
      <div className="max-w-[1600px] mx-auto grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5 lg:col-span-4">
          <p className="font-mono-tight text-zinc-500 mb-8">{t.about.label}</p>
          <div className="aspect-[3/4] w-full overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Salside film studio"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
              style={{ filter: "grayscale(0.3) contrast(1.05)" }}
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-7 lg:col-span-7 lg:col-start-6 flex flex-col justify-center">
          <h2
            className="text-4xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] text-white mb-12"
            data-testid="about-title"
          >
            <span className="font-editorial italic font-light text-zinc-300">A Paris agency. </span>
            <span>{t.about.title.replace("A Paris agency.", "").replace("Une agence parisienne.", "")}</span>
          </h2>
          <div className="space-y-6 max-w-2xl">
            <p className="text-zinc-300 text-lg leading-relaxed" data-testid="about-p1">{t.about.p1}</p>
            <p className="text-zinc-400 text-base leading-relaxed" data-testid="about-p2">{t.about.p2}</p>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-6 grid-divider">
            {t.about.stats.map((s) => (
              <div key={s.label} className="px-0 md:px-6 first:pl-0" data-testid={`about-stat-${s.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>
                <div className="text-5xl md:text-6xl chrome-text font-display">{s.value}</div>
                <div className="font-mono-tight text-zinc-500 mt-3">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
